/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Faq_TitleInputs */

const en_pc_online_faq_title = /** @type {(inputs: Pc_Online_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft Online questions`)
};

const zh_pc_online_faq_title = /** @type {(inputs: Pc_Online_Faq_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 在线版常见问题`)
};

/**
* | output |
* | --- |
* | "PdfCraft Online questions" |
*
* @param {Pc_Online_Faq_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_faq_title = /** @type {((inputs?: Pc_Online_Faq_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Faq_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_faq_title(inputs)
	return zh_pc_online_faq_title(inputs)
});
export { pc_online_faq_title as "pc.online.faq_title" }